import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  Text,
} from "@prismicio/editor-ui"
import type {
  SliceItemContent,
  SlicesContent,
} from "@prismicio/types-internal/lib/content"
import type { StaticSlices } from "@prismicio/types-internal/lib/customtypes"

interface LegacyCustomLabelSelectProps {
  sliceZone: StaticSlices
  sliceContent: SliceItemContent
  slices: SlicesContent
  onChange: (content: SlicesContent) => void
}

export function LegacyCustomLabelSelect(props: LegacyCustomLabelSelectProps) {
  const { sliceZone, onChange, slices, sliceContent } = props

  const labels = sliceZone.config?.labels?.[sliceContent.name]
  if (!labels) return null

  const selectedLabel = labels.find(
    (label) => label.name === sliceContent.maybeLabel,
  )

  function onSelect(label: string | undefined) {
    // update slice value with new label
    const value = slices.value.map((slice) =>
      slice.key === sliceContent.key ? { ...slice, maybeLabel: label } : slice,
    )

    onChange({
      ...slices,
      value,
    })
  }

  return (
    <>
      <Text component="span" variant="smallBold">
        •
      </Text>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <Button color="grey" size="small" endIcon="arrowDropDown" invisible>
            {selectedLabel?.display ?? "Slice variation"}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" maxHeight={256}>
          <DropdownMenuItem
            onSelect={() => onSelect(undefined)}
            endIcon={
              sliceContent.maybeLabel === undefined ? (
                <Icon name="check" />
              ) : undefined
            }
          >
            ...
          </DropdownMenuItem>
          {labels?.map((label) => (
            <DropdownMenuItem
              key={label.name}
              onSelect={() => onSelect(label.name)}
              endIcon={
                label.name === sliceContent.maybeLabel ? (
                  <Icon name="check" />
                ) : undefined
              }
            >
              {label.display ?? "[Missing display value]"}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
